import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Tenant\Branch\MarriageChildrenController::index
* @see app/Http/Controllers/Tenant/Branch/MarriageChildrenController.php:19
* @route '/user/nodes/{node}/marriage-children'
*/
export const index = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/user/nodes/{node}/marriage-children',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tenant\Branch\MarriageChildrenController::index
* @see app/Http/Controllers/Tenant/Branch/MarriageChildrenController.php:19
* @route '/user/nodes/{node}/marriage-children'
*/
index.url = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { node: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { node: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            node: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        node: typeof args.node === 'object'
        ? args.node.id
        : args.node,
    }

    return index.definition.url
            .replace('{node}', parsedArgs.node.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tenant\Branch\MarriageChildrenController::index
* @see app/Http/Controllers/Tenant/Branch/MarriageChildrenController.php:19
* @route '/user/nodes/{node}/marriage-children'
*/
index.get = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tenant\Branch\MarriageChildrenController::index
* @see app/Http/Controllers/Tenant/Branch/MarriageChildrenController.php:19
* @route '/user/nodes/{node}/marriage-children'
*/
index.head = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(args, options),
    method: 'head',
})

const marriageChildren = {
    index: Object.assign(index, index),
}

export default marriageChildren